<template>
    <div class="h-full w-full flex flex-col">
        <PipelinePartnerForm mode="create" :entities="entities" @created="onCreated" @close="$emit('close')" />
    </div>
</template>

<script>
import PipelinePartnerForm from "./form.vue";
export default {
    name: "pipeline-partners-create",
    emits: ["created", "close"],
    props: ["entities"],
    components: { PipelinePartnerForm, },
    methods: {
        onCreated(msg) {
            this.$emit('created', msg);
        }
    },
}
</script>